import { Injectable } from '@angular/core';

import { WindowService } from './window.service';
import { Version } from '../version/version';

@Injectable()
export class BrowserDetectionService {
  private userAgent: string;

  constructor(private window: WindowService) {
    this.userAgent = this.window.nativeWindow.navigator.userAgent;
  }

  public isChrome(): boolean {
    return (
      this.userAgent.indexOf('Chrome') > -1 &&
      this.userAgent.indexOf('Mobile Safari') === -1 &&
      this.userAgent.indexOf('Edge') === -1
    );
  }

  public isSafari(): boolean {
    return this.usesWebkit() && !this.isChrome();
  }

  public isIOSSafari(): boolean {
    return this.isIOS() && this.usesWebkit() && !this.userAgent.match(/CriOS/i);
  }

  public isIOS(): boolean {
    return !!this.userAgent.match(/iPad/i) || !!this.userAgent.match(/iPhone/i);
  }

  public usesWebkit(): boolean {
    return (
      this.userAgent.indexOf('AppleWebKit') > -1 &&
      this.userAgent.indexOf('Edge') === -1 &&
      this.userAgent.indexOf('IEMobile') === -1
    );
  }

  public getSafariVersion(): Version {
    const regexp: RegExp = new RegExp(
      /version\/([\w\.]+).+?(mobile\s?safari|safari)/i
    );
    const match: RegExpMatchArray = this.userAgent.match(regexp);
    if (match && match[1]) {
      return Version.fromString(match[1]);
    } else {
      return new Version(0, 0, 0);
    }
  }

  public hasNativeIntl(): boolean {
    return !!this.window.nativeWindow.Intl;
  }
}
